<template>
    <form @submit.prevent="handleSubmit" class="form-container search-form cia" data-cy="basic-search-container">
        <div class="flex w-full">
            <div class="flex flex-col w-full" data-cy="cia-cover-search">
                <a-input
                    v-model:value="search_form.basic_search"
                    class="border-default-blue-green my-2"
                    :placeholder="$t('cia.search_form.placeholders.search')"
                >
                    <template #suffix>
                        <SearchOutlined @click="handleSubmit" />
                    </template>
                </a-input>
            </div>
        </div>
    </form>
</template>

<script>
import { SearchOutlined } from '@ant-design/icons-vue';

export default {
    components: { SearchOutlined },
    props: {
        processing: {
            type: Boolean,
            default: false,
        },
        search_form: {
            type: Object,
            default: {},
        },
    },
    methods: {
        handleSubmit() {
            this.$emit('formSubmit');
        },
    },
};
</script>
